import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import fetch from 'features/common/fetch';
import { equalOrThreeDashes, fromIsoDate } from 'utils';

export const LeadTaskHistoryModalBody = ({ historyItems, onReloadFn }) => (
	<ComponentLoader fetchStorePath={fetch.constants.urls.taskHistory} onReload={onReloadFn}>
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell>{getLabelMessage('leadTaskHistory:dateOfChange')}</TableCell>
					<TableCell>{getLabelMessage('leadTaskHistory:nameChange')}</TableCell>
					<TableCell>{getLabelMessage('leadTaskHistory:description')}</TableCell>
					<TableCell>{getLabelMessage('leadTaskHistory:originalValue')}</TableCell>
					<TableCell>{getLabelMessage('leadTaskHistory:newValue')}</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{isEmpty(historyItems) ? (
					<TableHasNoResults />
				) : (
					historyItems.map((item, i) => (
						<TableRow key={i}>
							<TableCell>{fromIsoDate(item.dateModified)}</TableCell>
							<TableCell>{item.userCreated}</TableCell>
							<TableCell>{equalOrThreeDashes(item.comment)}</TableCell>
							<TableCell>{equalOrThreeDashes(item.oldValue)}</TableCell>
							<TableCell>{equalOrThreeDashes(item.newValue)}</TableCell>
						</TableRow>
					))
				)}
			</TableBody>
		</Table>
	</ComponentLoader>
);

LeadTaskHistoryModalBody.propTypes = {
	historyItems: PropTypes.array,
	onReloadFn: PropTypes.func,
};

export default LeadTaskHistoryModalBody;
